import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  ErrorHandlerService,
  NavigationService,
  supportUrlsLocalized,
  URLS,
} from 'i2g-ng-utils';
import { IconSizesEnum, IIcon } from '../../components/icon/icon.component';
import { AlignmentEnum } from '../../components/router-link/router-link.component';
import { snakeCase } from 'lodash';
import { ActivatedRoute } from '@angular/router';

// TODO [lib]: include translations for this page into the lib
@Component({
  selector: 'i2g-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit {
  rootRoute: string[];
  supportUrl: string;
  invoice2goLogo: IIcon;
  invoice2goUrl: string;
  AlignmentEnum: typeof AlignmentEnum = AlignmentEnum;

  constructor(
    private _route: ActivatedRoute,
    private _translateService: TranslateService,
    private _errorHandlerService: ErrorHandlerService,
    private _navigationService: NavigationService
  ) {}

  ngOnInit() {
    const ctaRoute = this._route.snapshot.data.ctaRoute;
    const pageUrl = this._navigationService.getLocationHref();
    const pathname = this._navigationService.getLocationPathname();
    const customGroupingKey = `404_${snakeCase(pathname)}`;

    this._errorHandlerService.alertSystem(new Error(customGroupingKey), {
      pageUrl,
      customGroupingKey,
    });

    this.rootRoute = ctaRoute;
    this.supportUrl = supportUrlsLocalized(
      URLS.SUPPORT,
      this._translateService.currentLang
    );
    this.invoice2goUrl = URLS.INVOICE2GO;
    this.invoice2goLogo = {
      name: 'invoice2go-logo-white',
      size: IconSizesEnum.custom,
    };
  }
}
